import * as React from 'react';

const LeaderboardTwoSvg = (props) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={16} height={16} fill='none' {...props}>
    <g stroke='#8B8B8B' strokeLinecap='round' strokeLinejoin='round' strokeWidth={1.161} clipPath='url(#a)'>
      <path d='M5.677 2.839h-1.29a1.29 1.29 0 0 0-1.29 1.29v9.033a1.29 1.29 0 0 0 1.29 1.29h7.742a1.29 1.29 0 0 0 1.29-1.29V4.129a1.29 1.29 0 0 0-1.29-1.29h-1.29' />
      <path d='M6.322 1.548h3.871c.357 0 .646.29.646.646v1.29a.645.645 0 0 1-.646.645h-3.87a.645.645 0 0 1-.646-.645v-1.29c0-.357.289-.646.645-.646Z' />
    </g>
    <defs>
      <clipPath id='a'>
        <path fill='#fff' d='M16 .258H.515v15.485H16z' />
      </clipPath>
    </defs>
  </svg>
);
export default LeaderboardTwoSvg;
